export default abstract class AbstractValidatorSet {
	public abstract getValidators(): object[];

	public getValidatorTranslationStrings(): Window['measurementSelectorVariables']['i18n']['validators'] {
		return window.measurementSelectorVariables.i18n.validators;
	}
}
